// ADR 0023 Sprint 7 Wave B — Connector instances API.
//
// Fetcher for GET /databus/tenants/{code}/connector-instances.
//
// The {code} segment is the tenant's short unique code (e.g. "access-bank"),
// NOT the numeric local PK and NOT the public_id UUID. Use TenantSummary.code.
//
// Security: The response intentionally excludes endpoint_config and
// source_routing. These fields are omitted by the backend. Do NOT add them
// to ConnectorInstance — their absence is a security boundary.
import { apiJson } from '@/api/client'
import { targetTenantHeader } from './context'
import type { ConnectorInstance } from './types'

export interface ConnectorInstancesResponse {
  items: ConnectorInstance[]
}

/**
 * GET /databus/tenants/{code}/connector-instances
 * Returns all connector instances for a tenant identified by its short code.
 *
 * code is TenantSummary.code (e.g. "access-bank").
 * targetTenantId is the tenant's public_id for the target-tenant-id header.
 */
export async function listConnectorInstances(
  code: string,
  targetTenantId?: string | null,
): Promise<ConnectorInstancesResponse> {
  return apiJson<ConnectorInstancesResponse>(
    `/databus/tenants/${encodeURIComponent(code)}/connector-instances`,
    { headers: targetTenantHeader(targetTenantId) },
  )
}
